import type { LayoutElement } from '../../types';
import type { EquipmentRenderDescriptor } from './equipmentSilhouettePorts';

export type EquipmentKitKind = 'stocker' | 'workcell' | 'lifter' | 'awp300' | 'fabProcess';

/** Same routing as FabEquipmentDetailLayer3D — keeps instanced shells aligned with full kits. */
export function resolveEquipmentKitKind(
  descriptor: EquipmentRenderDescriptor,
  meta?: Partial<Pick<LayoutElement, 'metadata' | 'customProperties'>> & { type?: string }
): EquipmentKitKind {
  if (descriptor.kind === 'stocker') return 'stocker';

  const cp = meta?.customProperties;
  const model = (
    cp?.equipmentModel ||
    cp?.model ||
    meta?.metadata?.name ||
    (meta as { type?: string } | undefined)?.type ||
    ''
  )
    .toString()
    .toUpperCase();

  const layoutType = (meta as { type?: string } | undefined)?.type;
  const rawType = (
    layoutType ||
    cp?.objectType ||
    cp?.equipmentType ||
    ''
  )
    .toString()
    .toUpperCase();

  if (
    model.includes('LIFTER') ||
    model.includes('VTU') ||
    model.includes('ELEVATOR') ||
    model.includes('LIFT') ||
    rawType.includes('LIFTER') ||
    rawType.includes('LIFT') ||
    rawType === 'STB' ||
    rawType === 'OHB' ||
    cp?.equipmentType === 'LIFTER' ||
    cp?.equipmentType === 'VERTICAL_LIFTER' ||
    layoutType === 'lifter' ||
    layoutType === 'stb' ||
    layoutType === 'ohb'
  ) {
    return 'lifter';
  }

  if (
    model.includes('AWP') ||
    model === 'EXISTING' ||
    cp?.equipmentType === 'EXISTING' ||
    cp?.equipmentType === 'AWP300'
  ) {
    return 'awp300';
  }

  if (
    model.includes('WORKCELL') ||
    model.includes('ROBOT') ||
    model.includes('INSPECT') ||
    cp?.equipmentType === 'CLEANROOM_WORKCELL'
  ) {
    return 'workcell';
  }

  if (
    model.includes('PROCESS') ||
    model.includes('ETCH') ||
    model.includes('CVD') ||
    model.includes('PVD') ||
    model.includes('LITHO') ||
    cp?.equipmentType === 'FAB_PROCESS' ||
    cp?.equipmentType === 'PROCESS_TOOL'
  ) {
    return 'fabProcess';
  }

  return 'workcell';
}
